import { render, staticRenderFns } from "./user-btn.vue?vue&type=template&id=720db000&scoped=true&"
import script from "./user-btn.vue?vue&type=script&lang=ts&"
export * from "./user-btn.vue?vue&type=script&lang=ts&"
import style0 from "./user-btn.vue?vue&type=style&index=0&id=720db000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720db000",
  null
  
)

export default component.exports